module.exports = __webpack_public_path__ + "img/mod-7.eab3b1e4.svg";